module.exports = __webpack_public_path__ + "img/email-light.c7c37239.svg";